













































































































import { Component, Mixins } from 'vue-property-decorator';
import { OrderInfo, OrderItem } from '@luxtag/papybase';
import { filter, map } from 'lodash';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import OrderMixin from '@/mixins/vue/OrderMixin';
import moment from 'moment';

@Component
export default class OrderList extends Mixins(OrderMixin, IsMobileMixin) {
    public orderItemTableHeaders = [
        {
            text: '',
            value: 'image',
            align: 'left',
            sortable: false,
            width: '40',
        },
        {
            text: 'Name',
            value: 'name',
            align: 'left',
            sortable: false,
        },
        {
            text: 'Serial No.',
            value: 'serialNumber',
            align: 'left',
            sortable: false,
        },
    ];

    public fetchOrderItemList(orderItems: OrderItem[]) {
        const orderItemMapped = map(orderItems, (item) => {
            const payload = JSON.parse(item.certificate!.payload!);

            return {
                image: payload.img,
                name: payload.Model,
                serialNumber: payload['Serial No.'],
            };
        });

        return orderItemMapped;
    }

    public created() {
        this.integrateOrdersFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });
    }

    public orderId(orderId: any, orderDate: string): string {
        const date = moment(orderDate).format('MMDDYYHHmmss');
        return `#${date}${orderId}`;
    }

    public orderDate(orderDate: string) {
        return moment(orderDate).format('MMMM Do YYYY, HH:mm:ss');
    }

    get filteredOrderList():OrderInfo[] {
        const filteredOrderList = filter(
            this.orderList,
            order => order.items.length > 0
                && order.items[0].certificate !== null
                && order.items[0].productId !== 2,
        );

        return filteredOrderList;
    }

    get orderList(): OrderInfo[] {
        return this.$store.getters.getOrders;
    }
}
